document.querySelectorAll('.featured-collection-swiper').forEach(function(swiper) {
    swiper.querySelectorAll('.swiper-wrapper > li').forEach(function(slide) {
        slide.classList.add('swiper-slide');
    });
    const swiperset = new Swiper(swiper, {
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        slidesPerView: 1.25,
        spaceBetween: 15,
        breakpoints: {
            480: {
              slidesPerView: 2,
              spaceBetween: 20
            },
            768: {
              slidesPerView: 4,
              spaceBetween: 25
            },
            1024: {
              slidesPerView: parseInt(swiper.getAttribute('data-rowsize')),
              spaceBetween: 30
            }
        }
    });
});

document.querySelectorAll('.ig-gallery-swiper').forEach(function(swiper) {
  const swiperset = new Swiper(swiper, {
      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
      },
      slidesPerView: 2.75,
      spaceBetween: 15,
      breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 25
          }
      }
  });
});